import { Component, EventEmitter, Output, inject } from '@angular/core';
import { FormGroup, FormBuilder, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-worker-dashboard-form',
    templateUrl: './worker-dashboard-form.component.html',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        TranslatePipe,
    ],
})
export class WorkerDashboardFormComponent {
  //TODO: Check why any is here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private fb = inject(FormBuilder); data = inject<{ title?: string, description?: string; }>('formData' as any) ?? {};

  form: FormGroup;

  @Output() dataChange = new EventEmitter<{ title?: string; description?: string }>();

  constructor() {
    const data = this.data;

    this.form = this.fb.group({
      title: [data.title || ''],
      description: [data.description || ''],
    });

    this.form.valueChanges.subscribe((value) => {
      this.dataChange.emit(value);
    });
  }
}
